import marked from 'marked'

export const linkRenderer = new marked.Renderer();

linkRenderer.link = function(href, title, text) {
  const link = marked.Renderer.prototype.link.call(this, href, title, text);
  return link.replace("<a","<a target='_blank' ");
};

